<script>
import SideMenuGroup      from '../side-menu-group';
import CustomSideMenuItem from '../side-menu-item/custom';
import Vue                from 'vue';

export default {
  name  : 'side-menu-group-custom',
  mixins: [SideMenuGroup],
  data  : function() {
    return {
      limit    : 4,
      analytics: { label: 'side_menu_group_custom' },
    };
  },
  // カスタムメニューグループコンポーネント作成ヘルパ
  make: function(group) {
    if (group.menuItems && group.menuItems.length) {
      group.menuItems = group.menuItems.map((menuItem) => {
        return menuItem.name === 'VueComponent' ? menuItem : CustomSideMenuItem.make(menuItem);
      });
    }
    return Vue.extend({
      mixins: [this],
      data  : () => group,
    });
  },
};
</script>
